<template>
  <div class="Melamine">
    <div class="title">Ethyl Acetate</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item" width="300">
        </el-table-column>
        <el-table-column prop="unit" label="Unit" width="100">
        </el-table-column>
        <el-table-column prop="Index" label="Index" width="300">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>180kg/drum, 14.4mt/20'FCL, 25.2mt/40'FCL. Or 21.5mt InISO Tank</p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        Ethyl acetate is used primarily as a solvent and diluent, being favored
        because of its low cost, low toxicity, and agreeable odor. For example,
        it is commonly used to clean circuit boards and in some nail vamish
        removers
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Item: "Appearance",
          unit: "%",
          Index: "Transparent liquid, no special odor",
        },
        {
          Item: "Purity",
          unit: "%",
          Index: "99.7 min",
        },
        {
          Item: "Alcohol",
          unit: "%",
          Index: "0.10 max",
        },
        {
          Item: "Water Content",
          unit: "%",
          Index: "0.05 max",
        },
        {
          Item: "Acetic",
          unit: "%",
          Index: "0.004 max",
        },
        {
          Item: "Color",
          unit: "%",
          Index: "10 max",
        },
        {
          Item: "Density",
          unit: "g cm3",
          Index: "0.897-0.902",
        },
        {
          Item: "Residue after evaporation",
          unit: "%",
          Index: "0.001 max",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
